import { Link } from 'react-router-dom'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import useHook, { returnManagementTabKey } from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../../components/ButtonBar'
export default function ReturnManagement() {
  const {
    checkedRadioKey,
    dateSource,
    isTableLoading,
    pagination,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
  } = useHook()

  const returnOrderDetailLinkRender = (text: any, record: any) => {
    return <Link to={`/srm/returnorder?id=${record.id}`}>{text}</Link>
  }
  const cancleOrderDetailLinkRender = (text: any, record: any) => {
    return <Link to={`/srm/cancelorder?id=${record.id}`}>{text}</Link>
  }
  const orderDetailLinkRender = (text: any, record: any) => {
    if (record.type === '取消单') {
      return <Link to={`/srm/cancelorder?id=${record.id}`}>{text}</Link>
    } else {
      return <Link to={`/srm/returnorder?id=${record.id}`}>{text}</Link>
    }
  }

  const listColumnDict: { [x in returnManagementTabKey]: any } = {
    退货申请: {
      listColumn: [
        {
          key: 'type',
          title: '单据类型',
        },
        {
          key: 'orderReturnNo',
          title: '单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'customer',
          title: '客户单位',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'returnNum',
          title: '件数',
        },
        {
          key: 'returnPrice',
          title: '金额',
        },
      ],
    },
    取消申请: {
      listColumn: [
        {
          key: 'orderReturnNo',
          title: '取消单号',
          render: cancleOrderDetailLinkRender,
        },
        {
          key: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'returnPrice',
          title: '订单金额',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
    退货中: {
      listColumn: [
        {
          key: 'orderReturnNo',
          title: '退货单号',
          render: returnOrderDetailLinkRender,
        },
        {
          key: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'returnNum',
          title: '退货数量',
        },
        {
          key: 'returnPrice',
          title: '退货金额',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
    已完成: {
      listColumn: [
        {
          key: 'type',
          title: '类型',
        },
        {
          key: 'state',
          title: '状态',
        },
        {
          key: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'completeTime',
          title: '完成时间',
        },

        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
    全部: {
      listColumn: [
        {
          key: 'type',
          title: '类型',
        },
        {
          key: 'state',
          title: '状态',
        },
        {
          key: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'completeTime',
          title: '完成时间',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
  }
  return (
    <div>
      <Search
        fieldsData={[
          'returnType',
          'orderReturnNo',
          'orderNo',
          'customer',
          'platform',
          'returnCount',
          'returnPrice',
        ]}
        onSearch={handleSearchClick}
        keyName="RETURNMANAGEMENT"
        ScreenKey="RETURNMANAGEMENT"
      />
      <div className={style['inner-content']}>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumnDict[checkedRadioKey].listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
import { Link } from 'react-router-dom'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import useHook, { returnManagementTabKey } from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../../components/ButtonBar'
export default function ReturnManagement() {
  const {
    checkedRadioKey,
    dateSource,
    isTableLoading,
    pagination,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
  } = useHook()

  const returnOrderDetailLinkRender = (text: any, record: any) => {
    return <Link to={`/srm/returnorder?id=${record.id}`}>{text}</Link>
  }
  const cancleOrderDetailLinkRender = (text: any, record: any) => {
    return <Link to={`/srm/cancelorder?id=${record.id}`}>{text}</Link>
  }
  const orderDetailLinkRender = (text: any, record: any) => {
    if (record.type === '取消单') {
      return <Link to={`/srm/cancelorder?id=${record.id}`}>{text}</Link>
    } else {
      return <Link to={`/srm/returnorder?id=${record.id}`}>{text}</Link>
    }
  }

  const listColumnDict: { [x in returnManagementTabKey]: any } = {
    退货申请: {
      listColumn: [
        {
          key: 'type',
          title: '单据类型',
        },
        {
          key: 'orderReturnNo',
          title: '单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'customer',
          title: '客户单位',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'returnNum',
          title: '件数',
        },
        {
          key: 'returnPrice',
          title: '金额',
        },
      ],
    },
    取消申请: {
      listColumn: [
        {
          key: 'orderReturnNo',
          title: '取消单号',
          render: cancleOrderDetailLinkRender,
        },
        {
          key: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'returnPrice',
          title: '订单金额',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
    退货中: {
      listColumn: [
        {
          key: 'orderReturnNo',
          title: '退货单号',
          render: returnOrderDetailLinkRender,
        },
        {
          key: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'returnNum',
          title: '退货数量',
        },
        {
          key: 'returnPrice',
          title: '退货金额',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
    已完成: {
      listColumn: [
        {
          key: 'type',
          title: '类型',
        },
        {
          key: 'state',
          title: '状态',
        },
        {
          key: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'completeTime',
          title: '完成时间',
        },

        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
    全部: {
      listColumn: [
        {
          key: 'type',
          title: '类型',
        },
        {
          key: 'state',
          title: '状态',
        },
        {
          key: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'applyTime',
          title: '申请时间',
        },
        {
          key: 'completeTime',
          title: '完成时间',
        },
        {
          key: 'platform',
          title: '下单平台',
        },
        {
          key: 'customer',
          title: '客户名称',
        },
        {
          key: 'consignee',
          title: '收件人',
        },
        {
          key: 'mobile',
          title: '联系方式',
        },
        {
          key: 'address',
          title: '收货地址',
        },
      ],
    },
  }
  return (
    <div>
      <Search
        fieldsData={[
          'returnType',
          'orderReturnNo',
          'orderNo',
          'customer',
          'platform',
          'returnCount',
          'returnPrice',
        ]}
        onSearch={handleSearchClick}
        keyName="RETURNMANAGEMENT"
        ScreenKey="RETURNMANAGEMENT"
      />
      <div className={style['inner-content']}>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumnDict[checkedRadioKey].listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
